// Truncate text to a specified length
export function truncateText(text, maxLength) {
    if (text.length <= maxLength) return text;
    return text.slice(0, maxLength) + '...';
}

// Format string to all lowercase
export function toLowerCase(string) {
    if (!string) return '';
    return string.toLowerCase();
}

// Format string to all uppercase
export function toUpperCase(string) {
    if (!string) return '';
    return string.toUpperCase();
}

// Capitalize the first letter of a string
export function capitalizeFirstLetter(string) {
    if (!string) return '';
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

// Format full name properly with capitalized words
export function formatName(name) {
    if (!name) return '';
    return name
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}

// Generate user abbreviation from name or username
export function generateAbbreviation(name) {
    if (!name) return 'NA';
    const parts = name.split(' ');
    if (parts.length > 1) {
        return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
    }
    return name.slice(0, 2).toUpperCase();
}
